module.exports = __webpack_public_path__ + "media/application/images/ecaas_certification-old-90ad5a03dd18fee1232d73a711c30567.png";